__turbopack_context__.v({
  "readMore": "view-module__NWLcAG__readMore",
});
